// extracted by mini-css-extract-plugin
export default {"contentWrapper":"MobilePaymentDetails_contentWrapper__wmXmZ"};